import './App.css';
import {ConfigProvider, Layout, theme} from "antd";
import {AuthProvider} from "./funcs/Authcontext";
import {Route, Routes} from "react-router-dom";
import PrivateRoutes1 from "./funcs/CheckAuth";
import Authpage from "./pages/Authpage";
import Mainpage from "./pages/Mainpage";
import Addtask from "./pages/Addtask";
import Sidebar from "./components/Header";

const {Content} = Layout;

function App() {
    return (
        <ConfigProvider
            theme={{
                algorithm: theme.darkAlgorithm,
                token: {
                    colorPrimary: "#a017ff",
                    colorInfo: "#a017ff",
                    fontSize: 14,
                    borderRadius: 8,
                    colorBgContainer: "#1f1f1f",
                    colorBgElevated: "#2a2a2a",
                    colorBgLayout: "#141414",
                },
                components: {
                    Menu: {
                        darkItemBg: "transparent",
                        darkItemSelectedBg: "rgba(160, 23, 255, 0.15)",
                        darkItemHoverBg: "rgba(160, 23, 255, 0.08)",
                    },
                    Card: {
                        colorBgContainer: "#1f1f1f",
                    },
                    Layout: {
                        siderBg: "#181818",
                        bodyBg: "#141414",
                    },
                },
            }}
        >
            <AuthProvider>
                <Routes>
                    <Route path="/login" element={<Authpage/>}/>
                    <Route element={<PrivateRoutes1/>}>
                        <Route exact path='/*' element={
                            <AppLayout><Mainpage/></AppLayout>
                        }/>
                        <Route exact path='/addtask' element={
                            <AppLayout><Addtask/></AppLayout>
                        }/>
                    </Route>
                </Routes>
            </AuthProvider>
        </ConfigProvider>
    );
}

function AppLayout({children}) {
    return (
        <Layout style={{minHeight: "100vh"}}>
            <Sidebar/>
            <Layout>
                <Content className="app-content">
                    {children}
                </Content>
            </Layout>
        </Layout>
    );
}

export default App;
